import React from 'react';
import { Button } from './ui/Button';
const CALENDAR_URL = 'https://calendar.app.google/PYPdcRoYne7QrNJA7';
export function CTASection() {
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 md:py-32 px-4 bg-carbon border-b border-gray-900" data-id="element-72">
      <div className="max-w-3xl mx-auto text-center" data-id="element-73">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-74">
          Deja de depender de la suerte. <br className="hidden md:block" data-id="element-75" />
          <span className="text-gold" data-id="element-76">Toma el control de tus reservas.</span>
        </h2>
        <p className="text-xl text-gray-400 mb-12" data-id="element-77">
          Agenda una llamada de diagnóstico gratuita y descubre cómo el Sistema
          A.C.E.™ puede llenar tus mesas esta misma semana.
        </p>
        <div className="flex flex-col items-center" data-id="element-78">
          <Button onClick={scrollToContact} className="w-full md:w-auto shadow-[0_0_40px_rgba(242,183,5,0.2)] text-lg md:text-xl px-10 py-5" data-id="element-79">
            QUIERO MI RESTAURANTE LLENO TODA LA SEMANA
          </Button>
          <a href={CALENDAR_URL} target="_blank" rel="noopener noreferrer" className="mt-6 text-gray-400 hover:text-gold transition-colors" data-id="element-80">
            O agenda directamente en nuestro calendario →
          </a>
        </div>
      </div>
    </section>;
}